
import { Component, Vue } from 'vue-property-decorator';
import { FileInterface, FolderInterface } from '@/components/file-browser/interfaces';
import FileBrowser from '@/components/file-browser/FileBrowser.vue';
import CreateFolder, { CreateFolderForm } from '@/views/pages/internal-file-manager/components/CreateFolder.vue';
import { AddFileForm } from '@/views/pages/internal-file-manager/components/AddFile.vue';
import FolderRepositoryInterface from '@/services/File-manager/interfaces/folder.interface';
import { FileEntity, FolderEntity } from '@fenix/file-manager-entities/file-manager-entities';
import Themeable from 'vuetify/lib/mixins/themeable';
import FileRepositoryInterface from '@/services/File-manager/interfaces/file.interface';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    CreateFolder,
    FileBrowser,
  },
  inject: [
    'folderRepository',
    'fileRepository',
  ],
})
export default class InternalFileManagerTree extends Vue {
  private readonly folderRepository!: FolderRepositoryInterface;
  private readonly fileRepository!: FileRepositoryInterface;

  private loading: boolean = false;

  private rootFolders: FolderEntity[] = [];

  private treeKey: number = 0;

  private async mounted(): Promise<void> {
    try {
      this.loading = true;
      const folders = await this.folderRepository.getRootFolders();
      this.rootFolders = folders.map((folder: FolderEntity) => Object.assign(folder, { files: [] }));
    } catch (err) {
      this.$errorDialog.show(err.message);
    } finally {
      this.loading = false;
    }
  }

  private async refreshFolders(): Promise<void> {
    this.loading = true;
    const folders = await this.folderRepository.getRootFolders();
    this.rootFolders = folders.map((folder: FolderEntity) => Object.assign(folder, { files: [] }));
    this.treeKey += 1;
    this.loading = false;
  }

  private async downloadFile(file: FileEntity): Promise<void> {
    await this.fileRepository.downloadFile(file);
  }

  private async fetchFolder(id: string): Promise<FolderEntity> {
    return await this.folderRepository.getFolder(id);
  }

  private async createFolder(data: CreateFolderForm): Promise<FolderEntity> {
    return await this.folderRepository.createFolder({
      name: data.name,
      isPrivate: data.private,
      parentId: data.parent,
    });
  }

  private async uploadFile(data: AddFileForm): Promise<void> {
    // return this.fileRepository.uploadFile({
    //   folderId: data.folderId,
    //   file: data.file,
    //   isPrivate: data.private,
    // });
  }

  private async deleteFolder(data: FolderEntity): Promise<void> {
    await this.folderRepository.deleteFolder(data.id);
  }

  private async deleteFile(data: FileEntity): Promise<void> {
    await this.fileRepository.deleteFiles([data.id]);
  }
}
